export default class Validator {
  static isValid(...args): boolean {
    const errorMessage = "Validation logic not defined. Implement method"
    throw Error(errorMessage);
  }
}